if (typeof window === 'undefined') {
	global.window = {};
}
window.loaders = {};

let loadScript = (() => {
	if (typeof window === 'undefined') {
		global.window = {};
	}
	window.loaders.actualData = undefined;
	window.define = data => {
		window.loaders.actualData = data;
	};
	
	window.loaders.cachedResults = {};
	window.loaders.promises = {};
	
	function load(url, isOnce, scriptId) {
		if (!window.loaders.promises[url]) {
			window.loaders.promises[url] = new Promise((resolve, reject) => {
				if (isOnce && window.loaders.cachedResults[url]) return resolve(window.loaders.cachedResults[url].data);
				
				let script = document.createElement('script');
				if (scriptId) {
					let oldScript = document.getElementById(scriptId);
					if (oldScript && oldScript.tagName === 'SCRIPT') {
						oldScript.parentNode.removeChild(oldScript);
					}
					script.id = scriptId;
				}
				script.onload = () => {
					let data = window.loaders.actualData;
					window.loaders.actualData = void 0;
					if (data instanceof Function) {
						data = data();
					}
					if (isOnce) {
						window.loaders.cachedResults[url] = {data: data};
					}
					resolve(data);
				};
				script.onerror = err => reject(err);
				script.src = url;
				document.head.appendChild(script);
			});
		}
		return window.loaders.promises[url];
	}
	
	return load;
})();

window.loaders.loadedStyleMap = {};
function loadStyle(url, isOnce) {
	return new Promise(function(resolve, reject) {
		if (isOnce && window.loaders.loadedStyleMap[url]) return resolve();
		window.loaders.loadedStyleMap[url] = true;
		
		let link = document.createElement('link');
		link.rel = 'stylesheet';
		link.onload = function() {
			resolve();
		};
		link.onerror = function(err) {
			reject(err);
		};
		link.href = url;
		document.head.appendChild(link);
	});
}

export default {loadScript, loadStyle};